(() => {
  const root = document.querySelector('[data-broadleaf-landing]');

  if (!root) {
    return;
  }

  const nav = root.querySelector('[data-bl-nav]');
  const canvas = root.querySelector('[data-bl-canvas]');
  const sections = root.querySelectorAll('[data-bl-reveal]');

  const setNavState = () => {
    if (!nav) {
      return;
    }

    nav.classList.toggle('is-scrolled', window.scrollY > 80);
  };

  setNavState();
  window.addEventListener('scroll', setNavState, { passive: true });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -80px 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  } else {
    sections.forEach((section) => section.classList.add('is-visible'));
  }

  if (!canvas) {
    return;
  }

  const context = canvas.getContext('2d');
  const particles = [];
  let width = 0;
  let height = 0;
  let animationFrame = null;
  let mouseX = 0;
  let mouseY = 0;

  const particleCount = Math.min(180, Math.max(70, Math.floor(window.innerWidth / 8)));

  const resize = () => {
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    width = canvas.clientWidth;
    height = canvas.clientHeight;
    canvas.width = Math.floor(width * ratio);
    canvas.height = Math.floor(height * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
  };

  const makeParticle = () => ({
    x: Math.random() * width,
    y: Math.random() * height,
    vx: (Math.random() - 0.5) * 0.32,
    vy: (Math.random() - 0.5) * 0.32,
    size: Math.random() * 1.6 + 0.5,
  });

  const initParticles = () => {
    particles.length = 0;

    for (let index = 0; index < particleCount; index += 1) {
      particles.push(makeParticle());
    }
  };

  const draw = () => {
    context.clearRect(0, 0, width, height);
    context.fillStyle = '#050505';
    context.fillRect(0, 0, width, height);

    particles.forEach((particle) => {
      const driftX = (mouseX - width / 2) * 0.00003;
      const driftY = (mouseY - height / 2) * 0.00003;

      particle.x += particle.vx + driftX;
      particle.y += particle.vy + driftY;

      if (particle.x < -20) particle.x = width + 20;
      if (particle.x > width + 20) particle.x = -20;
      if (particle.y < -20) particle.y = height + 20;
      if (particle.y > height + 20) particle.y = -20;

      context.beginPath();
      context.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      context.fillStyle = 'rgba(0, 240, 255, 0.72)';
      context.shadowColor = 'rgba(0, 240, 255, 0.7)';
      context.shadowBlur = 10;
      context.fill();
      context.shadowBlur = 0;
    });

    for (let i = 0; i < particles.length; i += 1) {
      for (let j = i + 1; j < particles.length; j += 1) {
        const a = particles[i];
        const b = particles[j];
        const dx = a.x - b.x;
        const dy = a.y - b.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < 145) {
          context.beginPath();
          context.moveTo(a.x, a.y);
          context.lineTo(b.x, b.y);
          context.strokeStyle = `rgba(0, 240, 255, ${0.12 * (1 - distance / 145)})`;
          context.lineWidth = 1;
          context.stroke();
        }
      }
    }

    animationFrame = window.requestAnimationFrame(draw);
  };

  const onResize = () => {
    resize();
    initParticles();
  };

  const onPointerMove = (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
  };

  resize();
  initParticles();
  draw();

  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('pointermove', onPointerMove, { passive: true });
  document.addEventListener('shopify:section:unload', () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
  });
})();
